export default __webpack_public_path__ + "static/media/fingo-screenshot-04.f9be07b6.png";